import React, { useState } from "react";
import api from "../api";
import { toast } from "sonner";
import { CheckCircle2 } from "lucide-react";
import { useAuth } from "../AuthContext";
import { AjutorButton } from "../AjutorButton";

const inp = {
  border: "1px solid #000", padding: "6px 8px", fontFamily: "Arial",
  fontSize: 12, color: "#000", background: "#fff", outline: "none",
};

const box = { border: "1px solid #000", padding: 16, margin: "0 auto 16px", maxWidth: 1152, background: "#fff" };

export default function Configurator() {
  const { user } = useAuth();
  const [personName, setPersonName] = useState(user?.name || "");
  const [phone, setPhone] = useState("");
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const appName = user?.tenant_name || "";

  const submit = async () => {
    if (personName.trim().length < 2) { toast.error("Introdu numele complet"); return; }
    if (phone.trim().length < 4) { toast.error("Introdu un numar de telefon valid"); return; }
    setSending(true);
    try {
      await api.post("/configurator/request", { person_name: personName.trim(), phone: phone.trim() });
      setSent(true);
      toast.success("Solicitarea a fost trimisa");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Eroare la trimitere");
    } finally {
      setSending(false);
    }
  };

  return (
    <div data-testid="configurator-page" style={{ fontFamily: "Arial", fontSize: 12, color: "#000", background: "#fff" }}>
      <AjutorButton file="ajutor_configurator.pdf" />
      <div data-testid="configurator-request-box" style={box}>
        {sent ? (
          <div data-testid="configurator-request-sent" style={{ display: "flex", gap: 8, alignItems: "flex-start" }}>
            <CheckCircle2 className="w-5 h-5" style={{ color: "#000" }} />
            <div>Solicitarea a fost trimisa. Veti fi contactat la numarul {phone}.</div>
          </div>
        ) : (
          <div>
            <div style={{ fontWeight: "bold", marginBottom: 10 }}>
              Doresc un configurator personalizat pentru afacerea mea{appName ? ` (${appName})` : ""}. Sunati-ma la numarul de mai jos.
            </div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 8, alignItems: "center" }}>
              <input
                data-testid="configurator-name-input"
                value={personName}
                onChange={(e) => setPersonName(e.target.value)}
                placeholder="Nume si prenume (ex: Popescu Ion)"
                style={{ ...inp, minWidth: 240 }}
              />
              <input
                data-testid="configurator-phone-input"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder="Numar de telefon"
                style={{ ...inp, minWidth: 180 }}
              />
              <button
                data-testid="configurator-submit-button"
                onClick={submit}
                disabled={sending}
                style={{ border: "1px solid #000", background: "#000", color: "#fff", padding: "6px 16px", fontFamily: "Arial", fontSize: 12, cursor: "pointer", opacity: sending ? 0.6 : 1 }}
              >
                {sending ? "Se trimite..." : "Trimite"}
              </button>
            </div>
          </div>
        )}
      </div>

      <div data-testid="configurator-info-box" style={box}>
        <p style={{ margin: "0 0 12px" }}>
          Un configurator online este un instrument digital care le permite utilizatorilor sa personalizeze, sa vizualizeze si sa comande produse sau servicii direct pe internet.
        </p>

        <div style={{ fontWeight: "bold", margin: "0 0 6px" }}>Cum functioneaza</div>
        <p style={{ margin: "0 0 4px" }}>Interfata vizuala: Foloseste imagini 2D sau modele 3D interactive.</p>
        <p style={{ margin: "0 0 4px" }}>Modificari in timp real: Schimbarile facute (culoare, dimensiune, materiale) se actualizeaza imediat pe ecran.</p>
        <p style={{ margin: "0 0 12px" }}>Calculul pretului: Valoarea produsului se modifica automat in functie de optiunile alese.</p>

        <div style={{ fontWeight: "bold", margin: "0 0 6px" }}>Exemple de utilizare</div>
        <p style={{ margin: "0 0 4px" }}>Mobilier si amenajari: Proiectarea de bucatarii, dulapuri sau canapele personalizate.</p>
        <p style={{ margin: "0 0 4px" }}>Auto: Personalizarea masinilor la comanda clientului (culoare, jante, dotari interioare).</p>
        <p style={{ margin: "0 0 12px" }}>E-commerce general: Haine, bijuterii sau echipamente tehnice facute pe masura.</p>

        <div style={{ fontWeight: "bold", margin: "0 0 6px" }}>Avantaje principale</div>
        <p style={{ margin: "0 0 4px" }}>Ofera o experienta de cumparare clara, similara cu cea dintr-un magazin fizic.</p>
        <p style={{ margin: "0 0 4px" }}>Reducerea erorilor de comanda pentru ca clientul vede exact ce va primi.</p>
        <p style={{ margin: "0 0 0" }}>Generarea automata a listei de preturi si a datelor de productie.</p>
      </div>
    </div>
  );
}
